<div class="tr-summary">
  <!-- Sticky Column -->
  <div class="td col-id sticky-col">
    <div class="layout-row layout-align-start-center gap-5">
       <bringoz-button type="tertiary" size="fit" (onClick)="onClose.emit()">
         <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
       </bringoz-button>

       <div ngbDropdown container="body">
         <button (click)="$event.stopPropagation();"
                 appBringozIdGenerator="menu-resource-card-resources"
                 class="action-menu"
                 ngbDropdownToggle aria-labelledby="action-menu">
           <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
         </button>
         <div ngbDropdownMenu>
           <button ngbDropdownItem
                   appBringozIdGenerator="dispatch-routes-resource-card-menu-resources"
                   type="tertiary"
                   (click)="dispatchAll(); $event.stopPropagation()">
             <div class="layout-row layout-align-start-center">
               <bringoz-icon iconName="dispatch" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
               <span class="br-body-2 font-weight-400">{{ 'Dispatch Routes' | translate }}</span>
             </div>
           </button>
         </div>
       </div>

       <bringoz-button *ngxPermissionsOnly="'planning.update'"
                       type="tertiary"
                       size="fit"
                       class="edit-resource-btn"
                       (onClick)="onEditResourceAllocation.emit({resource: resource, route: resourceRoutes?.[0], event: $event}); $event.stopPropagation();"
                       [ngbTooltip]="'Edit Resource Allocation' | translate"
                       openDelay="300"
                       container="body">
         <bringoz-icon iconName="edit-outline" classSize="sm" [fill]="resource.excluded ? '#CCCCCC' : '#484848'"></bringoz-icon>
       </bringoz-button>
       <span class="text-ellipsis font-weight-600">
         {{ resource.allocationName || resource.vehicleName }}
       </span>
    </div>
  </div>

  <div *ngIf="settings?.columns?.agent" class="td col-agent">
    <span class="text-ellipsis">{{ resource.agentName || '---' }}</span>
  </div>

  <div *ngIf="settings?.columns?.vehicle" class="td col-vehicle">
    <span class="text-ellipsis">{{ resource.mainLogisticsVehicleReference?.name || resource.vehicleType?.name || '---' }}</span>
  </div>

  <div *ngIf="settings?.columns?.routesCount" class="td col-routes-count">
    {{ resourceRoutes?.length || 0 }}
  </div>

  <div *ngIf="settings?.columns?.duration" class="td col-duration">
    {{ getResourceTotalDuration() | bringozTimeConvert }}
  </div>

  <div *ngIf="settings?.capacity?.weight" class="td col-capacity col-capacity-weight">
     <app-bringoz-primary-capacity [spots]="resource.totals?.totalWeight"
                                   [maxSpots]="resource?.capacity?.weight">
     </app-bringoz-primary-capacity>
  </div>

</div>
